<template>
  <div class="tech-nav">
    <div class="btn-control">
      <Techbtn :value.sync="currentTxt" :txtList="btnTxt" :isStateful="true" :isChangeable="false"></Techbtn>
    </div>
    <div class="tech-nav__content">
      <div class="logo_bar"><span>数据可视化展示平台</span></div>
    </div>
  </div>
</template>

<script>
import Techbtn from './tech-btn.vue'

export default {
  data () {
    return {
      currentTxt: '隐藏菜单',
      btnTxt: ['显示菜单', '隐藏菜单']
    }
  },
  components: {
    Techbtn
  }
}
</script>

<style lang="scss">
.tech-nav {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 87px;
  z-index: 1000;
  // background-color: #fff;
  // color: #ffffff;
  // box-shadow: 0 1px 4px rgba(0,21,41,.08);
  // display: flex;
  // align-items: center;
  // padding: 0;
  // margin-left: -331px;

  &__content {
    position: absolute;
    left: 50%;
    margin-left: -331px;
    .logo_bar {
      position: relative;
      padding: 0;
      margin: 0;
      width: 664px;
      height: 87px;
      line-height: 80px;
      text-align: center;
      vertical-align: middle;
      font-size: 40px;
      color: #00EDFF;//rgba(135,173,209,1.0);
      letter-spacing: 0;
      background-image: url(/static/img/title_bg@2x.png);
      background-size: 664px 88px;
      background-repeat: no-repeat;
    }
  }

  .btn-control {
    position: absolute;
    top: 23px;
    left: 50px;
    z-index: 1000;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/tech/topbar.vue